import { css } from 'lit'

export const numberStepperStyles = css`
    :host {
        --error-red: #b80113;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type='number'] {
        -moz-appearance: textfield;
    }

    .input-label {
        font-size: 11px;
        line-height: 24px;
    }

    .border {
        border: 1px solid #cfcfcf;
        border-radius: 4px;
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box; /* Firefox, other Gecko */
        box-sizing: border-box;
    }
    .border--error {
        border-color: var(--error-red);
    }

    .number-stepper-wrapper {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        gap: 10px;
        margin-top: 5px;
    }
    .number-input {
        border: none;
        outline: none;
        width: 35px;
        text-align: center;
    }
    .number-stepper {
        height: 24px;
        position: relative;
        text-align: center;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
    }

    .button-increment {
        border: none;
        cursor: pointer;
        color: #333;
        width: 16px;
        height: 16px;
    }

    .button-increment:disabled {
        cursor: not-allowed;
        opacity: 0.7;
    }

    .reset-button {
        height: 24px;
        width: 24px;
    }

    .button {
        background-color: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .buttons-wrapper {
        display: flex;
        align-items: center;
    }
    .input-label {
        font-size: 11px;
        line-height: 24px;
    }

    .align-left {
        justify-content: flex-start;
    }

    .align-right {
        justify-content: flex-end;
    }

    .error {
        position: absolute;
        color: var(--error-red);
        font-size: 11px;
        margin-top: 4px;
        width: max-content;
    }
    .invalid-input {
        border-color: var(--error-red) !important;
        color: var(--error-red) !important;
    }

    .error-left {
        left: 0;
    }
    .error-right {
        right: 0;
    }

    .relative {
        position: relative;
    }
`
